import React, { useMemo } from "react"
import parse from "html-react-parser"
import { Link } from "react-router-dom"
import moment from "moment"
import {cleanText, getFormattedDate, readableTarif} from "../../utils/functions"
import config from "../../config"

const BASE_URL = config.BASE_URL

// ─── Helpers ────────────────────────────────────────────────

function buildImageUrl(event) {
    if (event.is_xml === 1) return event.imgPathLarge ?? ""
    if (event.image_name) {
        return `${BASE_URL}img/events/${event.image_name}?${event.updated_at ?? ""}`
    }
    return `${BASE_URL}img/events/cover-${event.ev_id}.jpg`
}

function formatDate(isXml, dateFrom, dateTo) {
    if (isXml === 1) {
        if (getFormattedDate(dateFrom, "after")) {
            return `Jusqu'au ${moment(dateTo).format("HH:mm")}`
        }
        return getFormattedDate(dateFrom, "start")
    }
    return `${getFormattedDate(dateFrom, "start")} — ${moment(dateTo).format("HH:mm")}`
}

// ─── Component ──────────────────────────────────────────────

export default function MapInfoCard({ event, onClose }) {
    const imageUrl = useMemo(() => buildImageUrl(event), [event])

    const dateLabel = useMemo(
        () => formatDate(event.is_xml, event.dt_from, event.dt_to),
        [event.is_xml, event.dt_from, event.dt_to]
    )

    const priceLabel = useMemo(
        () => readableTarif(event.isFree, event.tarif, event.tarif_promo),
        [event.isFree, event.tarif, event.tarif_promo]
    )

    const parsedDescription = useMemo(() => {
        if (!event.details) return null
        const cleaned = event.details.replaceAll("<br>", "")
        let truncated = cleaned.length > 200 ? cleaned.slice(0, 200) + "…" : cleaned
        truncated = cleanText(truncated)
        return parse(truncated, { trim: true })
    }, [event.details])

    const isPartner = event.is_xml === 1 || event.is_xml === undefined
    const detailUrl = `/details/${event.ev_id}/${event.is_xml}`

    return (
        <div className="iw-card">
            {/* ─── Cover Image ─── */}
            <div className="iw-card__hero">
                <img
                    className="iw-card__img"
                    src={imageUrl}
                    alt={event.ev_name}
                    loading="lazy"
                />
                <div className="iw-card__hero-gradient" />

                {/* Distance badge */}
                {event.distance && (
                    <span className="iw-card__badge iw-card__badge--distance">
            {event.distance}
          </span>
                )}

                {/* Price badge */}
                {priceLabel && (
                    <span className="iw-card__badge iw-card__badge--price">
            {priceLabel}
          </span>
                )}
            </div>

            {/* ─── Body ─── */}
            <div className="iw-card__body">
                <time className="iw-card__date">{dateLabel}</time>

                <h3 className="iw-card__title">
                    {event.ev_name?.length > 40
                        ? event.ev_name.slice(0, 40) + "…"
                        : event.ev_name}
                </h3>

                {parsedDescription && (
                    <div className="iw-card__desc">{parsedDescription}</div>
                )}
            </div>

            {/* ─── Actions ─── */}
            <div className="iw-card__actions">
                {isPartner && event.deeplink && (
                    <a
                        href={event.deeplink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="iw-card__btn iw-card__btn--primary"
                    >
                        Réserver
                    </a>
                )}
                <Link
                    to={detailUrl}
                    target="_blank"
                    className="iw-card__btn iw-card__btn--secondary"
                >
                    Voir les détails →
                </Link>
            </div>
        </div>
    )
}
